import { useSyncExternalStore } from "react";

const listeners = new Set<() => void>();
function emit() {
  for (const l of listeners) l();
}

window.addEventListener("popstate", emit);

export function navigate(path: string) {
  window.history.pushState({}, "", path);
  emit();
}

export function usePath(): string {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => window.location.pathname,
  );
}
